import { IUserProfile } from "~/entity/Users/model/schema";

export interface ISubdivisionOption {
  value: string;
  label: string;
}

export interface IUsersFormValues {
  subdivisionSelect: ISubdivisionOption | null;
  fullname: string;
  phone: string;
  position: string;
  email: string;
  login: string;
  role: string | null;
  dealerSelect: number[];
}

export interface IUsersServerPayload {
  id: number;
  fullname: string;
  roleId: string | null;
  role: string | null;
  login: string;
  email: string;
  position: string;
  phone: string;
  subdivisionId: number | null;
  dealerIds: number[];
}

export const defaultFormValue: IUsersFormValues = {
  subdivisionSelect: null,
  fullname: "",
  phone: "",
  position: "",
  email: "",
  login: "",
  role: null,
  dealerSelect: [],
};

export interface IDealerOption {
  label: string;
  value: number;
}

export const toForm = (
  user: IUserProfile | undefined,
  dealers: IDealerOption[],
): IUsersFormValues => ({
  subdivisionSelect: user?.subdivision
    ? {
        value: String(user.subdivision.id),
        label: user.subdivision.name,
      }
    : null,
  fullname: user?.fullName || "",
  phone: user?.phone || "",
  position: user?.position || "",
  email: user?.email || "",
  login: user?.login || "",
  role: user?.role?.id ?? null,
  dealerSelect: dealers.map((d) => d.value),
});

export const toServer = (
  formData: IUsersFormValues,
  userId: number,
): IUsersServerPayload => ({
  id: userId,
  fullname: formData.fullname,
  roleId: formData.role,
  role: formData.role,
  login: formData.login,
  email: formData.email,
  position: formData.position,
  phone: formData.phone,
  subdivisionId: formData.subdivisionSelect
    ? Number(formData.subdivisionSelect.value)
    : null,
  dealerIds: formData.dealerSelect
    ? formData.dealerSelect.map((el) => Number(el))
    : [],
});
